import React, { createContext } from 'react'
import type { ReactElement } from 'react'

export type StoreContextType = ReturnType<typeof createAllStore> | null

export const StoreContext = createContext<StoreContextType>(null)

interface StoreProviderPropsType {
  children: ReactElement
  store: ReturnType<typeof createAllStore>
}

function StoreProvider(props: StoreProviderPropsType) {
  return (
    <StoreContext.Provider value={props.store}>
      {props.children}
    </StoreContext.Provider>
  )
}

export default StoreProvider
